import { isAndroid, isIOS } from '@/lib/device';

// The phone settings the app cannot see for itself (Focus or Do Not Disturb, how
// notifications show, battery saver), with the exact menu paths. Shown in the first-run
// setup and under Settings. Found on a real iPhone: docs/guides/CMB-CHATS-PHONE-SETUP-NOTES.md.
// The step-by-step guide shows both lists, whatever device reads it (`os`).

export function PhoneSettingsHelp({ os }: { os?: 'ios' | 'android' } = {}) {
  if (os ? os === 'android' : isAndroid) {
    return (
      <ol className="chats-setup-howto">
        <li><b>Do Not Disturb</b>: Settings, Notifications, Do Not Disturb. Turn it off, or add <b>CMB Chats</b> (or <b>Chrome</b>) to the apps allowed through.</li>
        <li><b>How they show</b>: Settings, Apps, <b>CMB Chats</b> (or <b>Chrome</b>), Notifications. Allow them, and allow <b>pop on screen</b>.</li>
        <li><b>Battery</b>: Settings, Apps, <b>CMB Chats</b> (or <b>Chrome</b>), Battery. Choose <b>Unrestricted</b> so the phone does not stop it in the background.</li>
      </ol>
    );
  }
  return (
    <ol className="chats-setup-howto">
      <li><b>Focus</b>: if a moon or person icon shows at the top of your screen, a Focus is on. Settings, Focus, open each one you use, Apps, and add <b>CMB Chats</b>.</li>
      <li><b>How they show</b>: Settings, Notifications, <b>CMB Chats</b>. Allow Notifications on, and tick <b>Lock Screen</b>, <b>Notification Centre</b> and <b>Banners</b>.</li>
      <li><b>Sounds</b>: on the same screen, turn <b>Sounds</b> on so a new lead is heard, not just seen.</li>
      {!os && !isIOS && <li>On a computer, notifications follow your browser and system settings.</li>}
    </ol>
  );
}
